export function ShowGenreButton(g, genresSelected, setGenresSelected) {


    function updateSelectGenres() {
        if (genresSelected.find(e => e.id === g.id)) {
            const a = [...genresSelected].filter(e => e.id !== g.id)
            setGenresSelected(a)
        } else {
            const a = [...genresSelected, g];
            setGenresSelected(a);
        }
    }

    return (
        <button
            class={(genresSelected.find(e => e.id === g.id) ? "bg-red-700" : "bg-red-500") + " select-none rounded-lg bg-red-500 py-1.5 px-3 *text-xs font-bold uppercase text-white shadow-md shadow-pink-500/20 transition-all hover:shadow-lg hover:shadow-pink-500/40 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"}
            data-ripple-light="true" onClick={() => updateSelectGenres()}>
            {g.name}
        </button>
    )
}